module.exports = __webpack_public_path__ + "media/images/save-culture-e7fc15332ffb9186071a9f3eec7f8e76.jpg";